import { render, staticRenderFns } from "./GlobalSearchClient.vue?vue&type=template&id=3e4e404c&"
import script from "./GlobalSearchClient.vue?vue&type=script&lang=js&"
export * from "./GlobalSearchClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports